export const RedoIcon = ({ ...props }) => {
  return (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m500.33 0h-47.41a12 12 0 0 0 -12 12.57l4 82.76a247.42 247.42 0 0 0 -188.92-87.33c-136.66 0-248.1 111.53-248 248.19.1 136.88 111.1 247.81 248 247.81a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0 -16.38-.55 176 176 0 1 1 29.82-230.31l-101.53-4.87a12 12 0 0 0 -12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12v-200.34a12 12 0 0 0 -12-12z" />
    </svg>
  );
};
